import React from "react";
import AspectRatio from "@mui/joy/AspectRatio";
import Link from "@mui/joy/Link";
import Card from "@mui/joy/Card";
import CardContent from "@mui/joy/CardContent";
import Chip from "@mui/joy/Chip";
import Typography from "@mui/joy/Typography";
import Box from "@mui/joy/Box";
import Button from "@mui/joy/Button";
import PublicIcon from "@mui/icons-material/Public";
import ButtonGroup from "@mui/joy/ButtonGroup";
import Grid from "@mui/joy/Grid";
import ExploreIcon from "@mui/icons-material/Explore";
import ScheduleIcon from "@mui/icons-material/Schedule";

export default function Tarjeta({
  titulo,
  descripcion,
  ubicacion,
  nivel,
  categoria,
  imagen,
  colornivel,
  latitud,
  longitud,
  ubicacionmapa,
  veraventura,
  pais,
  ciudad,
  fecha,
}) {
  return (
    <div>
      <Card
        variant="outlined"
        orientation="horizontal"
        sx={{
          width: "auto",
          marginTop: 2,
          "&:hover": {
            boxShadow: "md",
            borderColor: "neutral.outlinedHoverBorder",
          },
        }}
      >
        <AspectRatio ratio="0.8" sx={{ width: 90 }}>
          <img src={imagen} alt="" />
        </AspectRatio>
        <CardContent sx={{ minWidth: "80%" }}>
          <Typography level="title-lg">{titulo}</Typography>
          <Grid
            container
            spacing={1}
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Grid>
              <Typography level="body-xs">
                <PublicIcon fontSize="inherit" /> {pais}, {ciudad}
              </Typography>
            </Grid>
            <Grid>
              {" "}
              <Typography level="body-xs">
                <ScheduleIcon fontSize="inherit" /> {fecha}
              </Typography>
            </Grid>
          </Grid>
          <Link overlay underline="none" level="body-xs">
            {ubicacion}
          </Link>

          <Box>
            <Grid container spacing={2} sx={{ flexGrow: 1 }}>
              <Grid item xs={12} sm={6} md={6} lg={7}>
                <Chip
                  variant="solid"
                  color={colornivel}
                  size="sm"
                  sx={{ marginLeft: "2px", marginRight: "2px" }}
                >
                  {nivel}
                </Chip>
                <Chip
                  variant="outlined"
                  color="neutral"
                  size="sm"
                  sx={{ backgroundColor: "#123524", border: 0, color: "white" }}
                >
                  {categoria}
                </Chip>
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                lg={5}
                sx={{
                  display: "flex",
                  justifyContent: { xs: "center", sm: "flex-end" },
                }}
              >
                <ButtonGroup variant="outlined" size="xs">
                  <Button color="neutral" onClick={veraventura}>
                    Ver Más
                  </Button>
                  <Button
                    color="neutral"
                    startDecorator={<ExploreIcon />}
                    onClick={ubicacionmapa}
                  />
                </ButtonGroup>
              </Grid>
            </Grid>
          </Box>
        </CardContent>
      </Card>
    </div>
  );
}
